import React, { useEffect, useState } from 'react'
import ModalWrapper from '../../../../../../Components/CustomModal/ModalWrapper'
import { useDispatch, useSelector } from 'react-redux';
import { getAutoDrList } from '../../../../../../Store/prosafe/proTransaction/PurRequest/getAutoDrList';
import { Pencil, Save, Trash2, X } from 'lucide-react';
import { Dropdown } from 'primereact/dropdown';
import toast from 'react-hot-toast';
import { getAutoStoreQuotation } from '../../../../../../Store/prosafe/proTransaction/PurRequest/getAutoStoreQuotation';

const AutoPrModel = ({ modal, drIds, setItemsArr, storeQuotationId }) => {

    const dispatch = useDispatch();
    const [isEditing, setIsEditing] = useState(false);
    const [drawingItems, setDrawingItems] = useState([]);
    const [originalData, setOriginalData] = useState([]);

    useEffect(() => {
        if (modal.isShown) {
            if (storeQuotationId) {
                dispatch(getAutoStoreQuotation(storeQuotationId));
            } else if (drIds?.length > 0) {
                dispatch(getAutoDrList({ formData: { drawing_id: drIds } }));
            }
        }
    }, [modal.isShown, drIds, storeQuotationId]);


    const drItemData = useSelector((state) => state?.getAutoDrList?.user?.data) || [];
    const partyData = useSelector((state) => state.getParty?.user?.data) || [];
    const autoStoreQuotationData = useSelector((state) => state?.getAutoStoreQuotation?.user?.data) || [];

    const mapItemsWithDefaults = (data) => {
        return data.map(item => {
            const base = {
                ...item,
                require_qty: item.item_qty || item.required_qty || 0,
                rate: item.rate || 0,
                gst: item.gst || 0,
                pr_party: item.pr_party || '',
                remarks: item.remarks || '',
                discount: item.discount || 0,
                loading_charge: item.loading_charge || 0,
            };

            const { amount, discount_amount, taxable_amount, gst_amount, total_amount } = calculateAmounts(
                base.require_qty,
                base.rate,
                base.gst,
                base.discount,
                base.loading_charge
            );

            return { ...base, amount, discount_amount, taxable_amount, gst_amount, total_amount };
        });
    };

    useEffect(() => {
        if (drIds?.length > 0 && drItemData.length > 0) {
            const updated = mapItemsWithDefaults(drItemData);
            setDrawingItems(updated);
            setOriginalData(updated);
        }
    }, [drItemData, drIds]);

    useEffect(() => {
        if (storeQuotationId && autoStoreQuotationData.length > 0) {
            const updated = mapItemsWithDefaults(autoStoreQuotationData);
            setDrawingItems(updated);
            setOriginalData(updated);
        }
    }, [autoStoreQuotationData, storeQuotationId]);

    const calculateAmounts = (qty, rate, gst, discount, loading_charge = 0) => {
        const amount = (qty || 0) * (rate || 0);

        const discount_amount = (amount * (discount || 0)) / 100;
        const taxable_amount = amount - discount_amount;

        const gst_amount = (taxable_amount * (gst || 0)) / 100;
        const total_amount = taxable_amount + gst_amount + (loading_charge || 0);
        return { amount, discount_amount, taxable_amount, gst_amount, total_amount };
    };

    const handleSubmit = () => {
        const hasInvalid = drawingItems.some((item) => {
            return (
                !item.require_qty || item.require_qty <= 0 ||
                !item.rate || item.rate <= 0 ||
                !item.pr_party
            );
        });

        if (hasInvalid) {
            toast.error("Please fill all required fields: PR Qty, Rate, and Party for each item.");
            return;
        }

        const updatedItems = drawingItems?.map((e) => ({
            item_no: e?.item_no,
            item_id: e?.item_name,
            required_qty: e?.require_qty,
            // item_length: e?.item_length,
            // item_width: e?.item_width,
            item_weight: e?.item_weight,
            // item_radius: e?.item_radius,
            // item_thickness: e?.item_thickness,
            // assembly_weight: e?.assembly_weight,
            // assembly_surface_area: e?.assembly_surface_area,
            rate: e?.rate,
            amount: e?.amount?.toFixed(2),
            discount: e?.discount,
            discount_amount: e?.discount_amount?.toFixed(2),
            taxable_amount: e?.taxable_amount?.toFixed(2),
            gst: e?.gst,
            gst_amount: e?.gst_amount?.toFixed(2),
            loading_charge: e?.loading_charge?.toFixed(2),
            total_amount: e?.total_amount?.toFixed(2),
            pr_party: e?.pr_party,
            remarks: e?.remarks,
            isAuto: true,
        }));
        // setItemsArr(updatedItems);
        setItemsArr(prev => [...prev, ...updatedItems]);
        modal.hide();
        toast.success('Items added successfully');
    };

    return (
        <ModalWrapper
            title="Auto Items Details"
            isShown={modal.isShown}
            hide={modal.hide}
            footer={false}
            customSize={"modal-90w"}
        >
            <div className='row'>
                <div className="table-responsive">
                    <table className="table border-0 custom-table comman-table mb-0">
                        <thead>
                            <tr>
                                <th>Sr.</th>
                                <th>Item Name</th>
                                <th>Item No</th>
                                {/* <th>Length</th>
                                <th>Width</th> */}
                                {/* <th>Weight</th> */}
                                {/* <th>Radius</th>
                                <th>Thickness</th>
                                <th>Assembly Weight</th>
                                <th>Surface Area</th> */}
                                <th>Required Qty</th>
                                <th>Rate(₹)</th>
                                <th>Amount(₹)</th>
                                <th>Discount(%)</th>
                                <th>Discount Amount(₹)</th>
                                <th>Taxable Amount(₹)</th>
                                <th>GST(%)</th>
                                <th>GST Amount(₹)</th>
                                {storeQuotationId && <th>Loading Charge(₹)</th>}
                                <th>Total Amount(₹)</th>
                                <th>Party</th>
                                <th>Remarks</th>
                                <th className='text-end'>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {drawingItems.map((elem, i) => (
                                <tr key={elem._id}>
                                    <td>{i + 1}</td>
                                    <td>{elem.item || "-"}</td>
                                    <td>{elem.item_no || "-"}</td>
                                    {/* <td>{elem.item_length}</td>
                                    <td>{elem.item_width}</td> */}
                                    {/* <td>{elem.item_weight || "-"}</td> */}
                                    {/* <td>{elem.item_radius || "-"}</td>
                                    <td>{elem.item_thickness || "-"}</td>
                                    <td>{elem.assembly_weight}</td>
                                    <td>{elem.assembly_surface_area}</td> */}
                                    <td>
                                        {isEditing ? (
                                            <input
                                                type="number"
                                                style={{ width: "110px" }}
                                                className="form-control"
                                                value={elem.require_qty || ''}
                                                onChange={(e) => {
                                                    const updated = [...drawingItems];
                                                    updated[i].require_qty = parseFloat(e.target.value) || 0;
                                                    const amounts = calculateAmounts(updated[i].require_qty, updated[i].rate, updated[i].gst, updated[i].discount, updated[i].loading_charge || 0);
                                                    Object.assign(updated[i], amounts);
                                                    setDrawingItems(updated);
                                                }}
                                            />
                                        ) : elem.require_qty || "-"}
                                    </td>
                                    <td>
                                        {isEditing ? (
                                            <input
                                                type="number"
                                                className="form-control"
                                                style={{ width: "110px" }}
                                                value={elem.rate || ''}
                                                onChange={(e) => {
                                                    const updated = [...drawingItems];
                                                    updated[i].rate = parseFloat(e.target.value) || 0;
                                                    const amounts = calculateAmounts(updated[i].require_qty, updated[i].rate, updated[i].gst, updated[i].discount, updated[i].loading_charge || 0);
                                                    Object.assign(updated[i], amounts);
                                                    setDrawingItems(updated);
                                                }}
                                            />
                                        ) : elem.rate}
                                    </td>
                                    <td>{elem.amount?.toFixed(2)}</td>
                                    <td>
                                        {isEditing ? (
                                            <input
                                                type="number"
                                                style={{ width: "110px" }}
                                                className="form-control"
                                                value={elem.discount || ''}
                                                onChange={(e) => {
                                                    const updated = [...drawingItems];
                                                    updated[i].discount = parseFloat(e.target.value) || 0;

                                                    const amounts = calculateAmounts(
                                                        updated[i].require_qty,
                                                        updated[i].rate,
                                                        updated[i].gst,
                                                        updated[i].discount,
                                                        updated[i].loading_charge || 0
                                                    );

                                                    Object.assign(updated[i], amounts);
                                                    setDrawingItems(updated);
                                                }}
                                            />
                                        ) : elem.discount}
                                    </td>
                                    <td>{elem.discount_amount?.toFixed(2) || "-"}</td>
                                    <td>{elem.taxable_amount?.toFixed(2) || "-"}</td>
                                    <td>
                                        {isEditing ? (
                                            <input
                                                type="number"
                                                style={{ width: "110px" }}
                                                className="form-control"
                                                value={elem.gst || ''}
                                                onChange={(e) => {
                                                    const updated = [...drawingItems];
                                                    updated[i].gst = parseFloat(e.target.value) || 0;
                                                    const amounts = calculateAmounts(updated[i].require_qty, updated[i].rate, updated[i].gst, updated[i].discount, updated[i].loading_charge || 0);
                                                    Object.assign(updated[i], amounts);
                                                    setDrawingItems(updated);
                                                }}
                                            />
                                        ) : elem.gst}
                                    </td>
                                    <td>{elem.gst_amount?.toFixed(2) || "-"}</td>
                                    {storeQuotationId && (
                                        <td>
                                            {isEditing ? (
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    style={{ width: "110px" }}
                                                    value={elem.loading_charge || ''}
                                                    onChange={(e) => {
                                                        const updated = [...drawingItems];
                                                        updated[i].loading_charge = parseFloat(e.target.value) || 0;

                                                        const amounts = calculateAmounts(
                                                            updated[i].require_qty,
                                                            updated[i].rate,
                                                            updated[i].gst,
                                                            updated[i].discount,
                                                            updated[i].loading_charge
                                                        );

                                                        Object.assign(updated[i], amounts);
                                                        setDrawingItems(updated);
                                                    }}
                                                />
                                            ) : elem.loading_charge}
                                        </td>
                                    )}
                                    <td>{elem.total_amount?.toFixed(2) || "-"}</td>
                                    <td>
                                        {isEditing ? (
                                            <Dropdown
                                                value={elem.pr_party}
                                                options={partyData.map(e => ({ label: e.name, value: e._id }))}
                                                onChange={(e) => {
                                                    const updated = [...drawingItems];
                                                    updated[i].pr_party = e.value;
                                                    setDrawingItems(updated);
                                                }}
                                                placeholder="Select Party"
                                                optionLabel="label"
                                                filter
                                                disabled={!!storeQuotationId}
                                                className="w-100 multi-prime-react"
                                            />
                                        ) : partyData.find(p => p._id === elem.pr_party)?.name || "-"}
                                    </td>
                                    <td>
                                        {isEditing ? (
                                            <input
                                                type="text"
                                                style={{ width: "110px" }}
                                                className="form-control"
                                                value={elem.remarks || ''}
                                                onChange={(e) => {
                                                    const updated = [...drawingItems];
                                                    updated[i].remarks = e.target.value;
                                                    setDrawingItems(updated);
                                                }}
                                            />
                                        ) : elem.remarks}
                                    </td>
                                    <td className="d-flex justify-content-end">
                                        <a
                                            // type="button"
                                            className="action-icon p-1 mx-1"
                                            onClick={() => {
                                                const filtered = drawingItems.filter(item => item._id !== elem._id);
                                                setDrawingItems(filtered);
                                            }}
                                        >
                                            <Trash2 />
                                        </a>
                                    </td>
                                </tr>
                            ))}
                            {drawingItems?.length === 0 ? (
                                <tr>
                                    <td colSpan="999">
                                        <div className="no-table-data">
                                            No Data Found!
                                        </div>
                                    </td>
                                </tr>
                            ) : null}
                        </tbody>
                    </table>
                </div>

                <div className="mt-3 text-end">
                    {isEditing ? (
                        <>
                            <button className="btn btn-success mx-2" onClick={() => setIsEditing(false)}>
                                <Save className="me-1" /> Save
                            </button>
                            <button className="btn btn-secondary mx-2" onClick={() => {
                                setDrawingItems([...originalData]);
                                setIsEditing(false);
                            }}>
                                <X className="me-1" /> Cancel
                            </button>
                        </>
                    ) : (
                        <button className="btn btn-outline-primary mx-2" onClick={() => setIsEditing(true)}>
                            <Pencil className="me-1" /> Edit All
                        </button>
                    )}
                    <button className="btn btn-primary" onClick={handleSubmit}>
                        Submit
                    </button>
                </div>
            </div>
        </ModalWrapper>
    )
}

export default AutoPrModel